module.exports = __webpack_public_path__ + "static/media/Create_limited_time_offers.d4a17402.svg";